import { Component, input, output } from '@angular/core';

@Component({
  selector: 'gs-event-selection-cell',
  template: `
    <input
      type="checkbox"
      [checked]="checked()"
      aria-label="Toggle event selection"
      (change)="onToggle($event)" />
  `,
  styles: [
    `
      :host {
        display: inline-flex;
      }
    `,
  ],
})
export class GsEventSelectionCellComponent {
  readonly checked = input(false);

  readonly toggled = output<boolean>();

  protected onToggle(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.toggled.emit(checkbox.checked);
  }
}
